import ajv from '@f/validation/ajv'
import * as ForestSchema from '@f/validation/schema/datalayer/forest'
import { ISimpleEventForest, IEventSelectionForest, IEventSelectionTrees, IEventForestInfoEdited } from '@f/validation/types/dataLayer'

export const validateBeginForest = ajv.compile<ISimpleEventForest>(ForestSchema.BeginForestSchema)
export const validateSelectionForest = ajv.compile<IEventSelectionForest>(ForestSchema.SelectionForestSchema)
export const validateSelectionTrees = ajv.compile<IEventSelectionTrees>(ForestSchema.SelectionTreesSchema)
export const validateForestInfoEdited = ajv.compile<IEventForestInfoEdited>(ForestSchema.ForestInfoEditedSchema)